import { gql } from 'graphql-tag';
import { ResourceRequestStatus } from '~/types';
import { specificResourceRequestWithAllocationsFragment } from '~/modules/resourcing/common/fragments';
import { mapToServiceRequest } from '../../util';

export const REJECTED_RESOURCE_REQUEST = gql`
  mutation markResourceRequestAsRejected(
    $input: MarkResourceRequestAsRejectedInput!
  ) {
    markResourceRequestAsRejected2(input: $input) {
      resourceRequest {
        ...SpecificResourceRequestWithAllocation
      }
    }
  }
  ${specificResourceRequestWithAllocationsFragment}
`;

export const invokeMarkResourceRequestAsRejected = markResourceRequestAsRejected => ({
  request,
  chartSelectedTab,
  requestAccessLevel,
  cacheUpdateFunctions
}) =>
  markResourceRequestAsRejected(
    mapToServiceRequest({
      request,
      responseType: 'markResourceRequestAsRejected2',
      responseTypeName: 'MarkResourceRequestAsRejectedResult',
      requestStatus: ResourceRequestStatus.Rejected,
      chartSelectedTab,
      requestAccessLevel,
      cacheUpdateFunctions
    })
  );
